import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";

// Aggressively update service worker for installed PWA
if ("serviceWorker" in navigator) {
  // Check for updates every 60 seconds
  const checkForUpdates = () => {
    navigator.serviceWorker.getRegistrations().then((registrations) => {
      registrations.forEach((registration) => {
        registration.update().catch(() => {
          // Silently handle SW update failures (e.g. on proxied custom domains)
        });
      });
    }).catch(() => {});
  };

  // Check on load and periodically
  checkForUpdates();
  setInterval(checkForUpdates, 60 * 1000);

  // Reload when a new service worker takes over
  let refreshing = false;
  navigator.serviceWorker.addEventListener("controllerchange", () => {
    if (!refreshing) {
      refreshing = true;
      window.location.reload();
    }
  });
}

createRoot(document.getElementById("root")!).render(<App />);
